import type { Map } from "../../../types/content";

export function getGoogleMapsLink({ location, zoom }: Map) {
  return `https://maps.google.com/maps/?q=${location.lat}+${location.lon}&ll=${location.lat}+${location.lon}&z=${zoom}`;
}
